import { render, staticRenderFns } from "./SampleAuditTrail.vue?vue&type=template&id=7c51db38"
import script from "./SampleAuditTrail.vue?vue&type=script&lang=js"
export * from "./SampleAuditTrail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports